export default {"src":"/_next/static/media/header_icon_group3.bd2bde28.svg","height":194,"width":145,"blurWidth":0,"blurHeight":0};